export const getAnalyticsCode = (analytics, position) => {
    const decodeBase64 = (str) => {
    if (!str) return "";
    try {
      return typeof atob === "function"
        ? atob(str)
        : Buffer.from(str, "base64").toString("utf8");
    } catch {
      return "";
    }
  };

  const stripScriptWrapper = (html) =>
    html ? html.replace(/<\/?script[^>]*>/gi, "") : "";

  const headerScripts = [];
  const footerScripts = [];

  Object.entries(analytics || {}).forEach(([name, cfg]) => {
    if (!cfg?.enabled) return;
    if (cfg.header?.script) {
      headerScripts.push({ name, code: decodeBase64(cfg.header.script)});
    }
    if (cfg.footer?.script) {
      footerScripts.push({ name, code: decodeBase64(cfg.footer.script)});
    }
  });

  if(position == "header") {
    return headerScripts;
  } else {
    return footerScripts;
  }
}

export const parseScriptTags = (code) => {
    const scriptRegex = /<script([^>]*)>([\s\S]*?)<\/script>/gi;
    const scripts = [];
    let match;

    while ((match = scriptRegex.exec(code))) {
        const attrs = match[1]; 
        const content = match[2];
        const props = {};

        // Parse attributes
        if (attrs) {
        const asyncMatch = /\basync\b/.test(attrs);
        if (asyncMatch) props.async = true;

        const srcMatch = attrs.match(/src="([^"]+)"/);
        if (srcMatch) props.src = srcMatch[1];

        const deferMatch = /\bdefer\b/.test(attrs);
        if (deferMatch) props.defer = true;
        }

        scripts.push({ props, content });
    }

    return scripts;
    };